export default __webpack_public_path__ + "static/media/popup-img.6ad3e568.jpg";